import React, { forwardRef } from 'react';
import { makeStyles } from 'tss-react/mui';
import domPurify from 'utils/domPurify';

interface IProps {
  content: string;
  className?: string;
  variant?: string;
}

const useStyles = makeStyles<IProps>()((theme, props: IProps) => ({
  root: {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ...theme.typography[props.variant],
    display: 'box',
    boxOrient: 'vertical',
    margin: theme.spacing(0, 0, 1),
    wordBreak: 'break-word',
    '& p': {
      margin: 0,
    },
    '& ul': {
      margin: 0,
    },
    '& a': {
      textDecoration: 'none',
      color: theme.palette.primary.main,
    },
    '& .ql-align-center': { textAlign: 'center' },
    '& .ql-align-right': { textAlign: 'right' },
    '& .ql-align-justify': { textAlign: 'justify' },
    '& .ql-direction-rtl': { direction: 'rtl' },
  },
}));

/* eslint-disable react/no-danger */
const FormattedHtml = forwardRef<HTMLDivElement, IProps>(({ className, content, ...props }, ref) => {
  const { classes, cx } = useStyles(
    { ...props, content },
    {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      props,
    },
  );
  return (
    <div
      ref={ref}
      className={cx(classes.root, className)}
      dangerouslySetInnerHTML={{
        __html: domPurify.sanitize(content, { ALLOWED_ATTR: ['target', 'href', 'rel', 'class', 'dir'] }),
      }}
    />
  );
});

export default FormattedHtml;
